import React, { FC, useEffect, useState } from "react";
import styled from "styled-components";
import { Line, Group, Text } from "react-konva";
import { IReportRoofEdge, IReportRoofPoint, IReportWindowHole } from "../Model";
import {
  getCorrectedPoints,
  getFullPoints,
  getPointsForCenetrRoofPart,
  HEIGHT_DRAW_AREA,
  WIDTH_DRAW_AREA,
} from "./RoofPart";

// Przełożenie punktów na kolekcję dla komponentu Line
const getPointsForLineComponent = (pointIds: any[], roofPoints: any[]) => {
  let arr = [];
  for (const id of pointIds) {
    const p = roofPoints.find((x) => x.id === id);
    if (p) {
      arr.push(p.x);
      arr.push(p.y);
    }
  }
  return arr;
};

type Props = {
  windowHole: IReportWindowHole;
  points: IReportRoofPoint[];
  edges: IReportRoofEdge[];
  basic: boolean;
};

const WindowHoleComponent: FC<Props> = ({ windowHole, points, edges, basic }) => {
  return (
    <Container>
      <Group>
        {points.length > 0 && (
          <Line
            points={getPointsForLineComponent(windowHole.pointIds, points)}
            fill={"#fafafa"}
            closed={true}
            stroke="#2e2e2e"
            strokeWidth={0.5}
          />
        )}

        {points.length > 0 && (
          <Text
            fill="#e2e2e2"
            fontSize={10}
            x={getPointsForCenetrRoofPart(getFullPoints(windowHole.pointIds, points)).x}
            y={getPointsForCenetrRoofPart(getFullPoints(windowHole.pointIds, points)).y}
            offsetX={4}
            offsetY={4}
            text="O"
          />
        )}
      </Group>
    </Container>
  );
};
export default WindowHoleComponent;

const Container = styled(Group)``;
